import { render, staticRenderFns } from "./vehicleInsuranceList.vue?vue&type=template&id=cab730c6"
import script from "./vehicleInsuranceList.vue?vue&type=script&lang=js"
export * from "./vehicleInsuranceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports